import ReactDOM from "react-dom";

const AddPlayerModal = ({ isOpen, closeModal, children }) => {
	return ReactDOM.createPortal(
		<div
			className={`z-50 fixed inset-0 bg-black/75 transition-opacity duration-300 flex items-end lg:items-center justify-center 
				${
					isOpen
						? "opacity-100 pointer-events-auto"
						: "opacity-0 pointer-events-none"
				}`}
			onClick={closeModal}
		>
			<div
				className={` min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white rounded-t-3xl lg:rounded-xl shadow-lg transform transition-all duration-300
					${isOpen ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"} 
					lg:${isOpen ? "translate-y-0 scale-100" : "translate-y-10 scale-95 opacity-0"}`}
				onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
			>
				<div className="p-6 pb-8">
					<div className="flex justify-between items-center mb-4">
						<h2 className="text-2xl font-bold text-center flex-1">
							Ajouter un joueur
						</h2>
						<button
							onClick={closeModal}
							className="text-gray-700 hover:text-gray-900"
						>
							✖️
						</button>
					</div>

					{/* Modal Content */}
					{children}
				</div>
			</div>
		</div>,
		document.body // This ensures it's attached to the body, preventing containment issues.
	);
};

export default AddPlayerModal;
